import { isProdLike } from "@imi/utils/env.ts";
import {
  ErrorBoundaryActions,
  ErrorBoundaryActionsProps,
} from "./ErrorBoundaryActions";
import styles from "./ErrorStatus.module.css";
import { getErrorMessage } from "./helpers/getErrorMessage";

type ErrorStatusProps = {
  error?: unknown;
  message: string;
  title: string;
} & ErrorBoundaryActionsProps;

export function ErrorStatus({
  error,
  message,
  title,
  ...props
}: ErrorStatusProps) {
  return (
    <div className={styles.ErrorStatus}>
      <div className={styles.ErrorStatusContent}>
        <h1>{title}</h1>
        <span>{message}</span>
      </div>
      {!!error && !isProdLike(import.meta.env.VITE_ENVIRONMENT) && (
        <pre>{getErrorMessage(error)}</pre>
      )}
      <ErrorBoundaryActions {...props} />
    </div>
  );
}
